import * as angular from 'angular';

"use strict";

angular.module('FieldModule')
    .directive('digitalSignatureField', digitalSignatureFieldDirective)
    .directive('digitalSignatureFieldPrint', digitalSignatureFieldPrintDirective)
    .directive('digitalSignatureFieldBuild', digitalSignatureFieldBuild)
    .service('digitalSignatureField', digitalSignatureField);

digitalSignatureFieldDirective.$inject = ['Configuration'];

/**
 * Directive object that will build the field.
 *
 * @returns {{controller: string, restrict: string, templateUrl: string}}
 * @constructor
 */
function digitalSignatureFieldDirective(Configuration) {
    let directive = this;
    let version = Configuration.getVersion();
    let random = Configuration.getRandomValue();
    let templateUrl = 'components/field/template/digital-signature/field.html?v=' + version + 'rand=' + random;

    return ({
        controller: "FieldController",
        restrict: "A",
        templateUrl: templateUrl
    });
}

digitalSignatureFieldPrintDirective.$inject = ['Configuration'];

/**
 * Directive that will show the field result in the table.
 *
 * @returns {{controller: string, restrict: string, templateUrl: string}}
 * @constructor
 */
function digitalSignatureFieldPrintDirective(Configuration) {
    let directive = this;
    let version = Configuration.getVersion();
    let random = Configuration.getRandomValue();
    let templateUrl = 'components/field/template/digital-signature/print.html?v=' + version + 'rand=' + random;

    return ({
        controller: "FieldController",
        restrict: "A",
        templateUrl: templateUrl
    });
}

/**
 * Service constructor.
 * @constructor
 */
function digitalSignatureField() {
    let service = this;

    /**
     * Returns the initial Parameters for this field, to be distinguished from other parameters the field may have in the future after creating it
     */
    service.getInitialParams = async function () {
        try {
            let initialParams = {
                'defaultText': {
                    'validation': {
                        'required': false
                    }
                },
                'signatureAuthType': {
                    'validation': {
                        'required': true,
                        'validationResponse': 'Please select an authentication or signature option',
                        'requiredType': 'stringMustNotBeEmpty'
                    }
                },
            }

            return initialParams;

        } catch (e) {
            console.log(e);
        }
    }
}


/**
 * Directive object that will build or edit the field.
 *
 * @returns {{controller: string, restrict: string, templateUrl: string}}
 * @constructor
 */
function digitalSignatureFieldBuild(Configuration) {
    let directive = this;
    let version = Configuration.getVersion();
    let random = Configuration.getRandomValue();
    let templateUrl = 'components/field/template/digital-signature/build-edit.html?v=' + version + 'rand=' + random;

    return ({
        controller: "FieldController",
        restrict: "A",
        templateUrl: templateUrl
    });
}